export default __webpack_public_path__ + "static/media/3.b9c07845.png";